"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloserCouponState = /** @class */ (function () {
    function CloserCouponState() {
        this.showCloserCouponModal = false;
    }
    return CloserCouponState;
}());
exports.default = CloserCouponState;
//# sourceMappingURL=CloserCouponState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/CloserCoupon/CloserCouponState.js
// module id = 2247
// module chunks = 8